import React from 'react';
import type { RenderElementProps } from 'slate-react';

export const HorizontalRule = ({ attributes }: RenderElementProps) => <hr {...attributes} />;
